/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the exclusive property of SKD RATWANI Technology &
 * Software Solutions Pvt Ltd, operating as "SkillDelivery". Unauthorized
 * copying, modification, distribution, or use of this software, via any
 * medium, is strictly prohibited without express written permission.
 *
 * For licensing inquiries: legal@skilldelivery.co.in
 *
 * Registered Office: Sitapur, Uttar Pradesh, India - 261001
 * Jurisdiction: Noida, Uttar Pradesh, India - 201301
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import './AdminLayout.css';

const AdminLayout = ({ children, showBackButton = false, backPath = '/admin/dashboard' }) => {
  const navigate = useNavigate();

  return (
    <div className="admin-layout">
      {/* Header with Logo */}
      <header className="admin-header">
        <div className="admin-header-content">
          <div className="logo-section">
            <img src="/logo.jpg" alt="SkillDelivery" className="admin-logo" />
            <div className="logo-text">
              <span className="brand-name">SkillDelivery</span>
              <span className="admin-badge">Admin Console</span>
            </div>
          </div>

          {showBackButton && (
            <button className="header-back-button" onClick={() => navigate(backPath)}>
              ← Back
            </button>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="admin-content">
        {children}
      </main>

      {/* Footer */}
      <Footer hasSidebar={false} />
    </div>
  );
};

export default AdminLayout;
